const pxRegex = /(\d+)px/
export const getNumbersInPxString = (pixelString: string): number =>
  Number(pixelString.match(pxRegex)[1])

export const doesStringMatchesRegex = (regExp: RegExp, stringValue: string) => {
  return regExp.test(stringValue)
}
